const userRoleOptions = [
  { key: "project_manager", value: "Project Manager" },
  { key: "chief_engineer", value: "Chief Engineer" },
  { key: "senior_engineer", value: "Senior Engineer" },
  { key: "junior_engineer", value: "Junior Engineer" },
  { key: "quality_engineer", value: "Quality Engineer" },
  { key: "safety_engineer", value: "Safety Engineer" },
  { key: "store_manager", value: "Store Manager" },
  { key: "planning_manager", value: "Planning Manager" },
  { key: "purchase_manager", value: "Purchase Manager" },
  { key: "technical_director", value: "Technical Director" }
];

export default userRoleOptions;
